import React, { useState, Fragment, useRef, useEffect } from 'react';
import { FieldArray } from 'formik';
import TextFieldPOS from '../../components/TextFieldPOS';
import ToogleFieldPOS from '../../components/ToogleFieldPOS';
import CustomePagination from '../../../../../components/Pagination/CustomePagination';
import CreatableSelect from '../../../../../components/Select/CreatableSelect';
import StickyButtons from '../../../../../components/StickyButtons';
import ConfirmUnsavedChangesModal from '../../components/ConfirmUnsavedChangesModal';
import { discountOptionsModified } from '../../utils/utils';
import Button from '@material-ui/core/Button';
import { useContext } from 'react';
import {
  MainDiv,
  PaginationWrapper,
  Body,
  DiscountDiv,
  DiscountNameCell,
  POSDiv,
  DiscountHeader,
  POSHeader,
  POSFieldWrapper,
  POSValueCell,
  LineDivider,
  ToogleFieldPOSWrapper,
  SelectDiv,
} from '../../styles/styles';
import { CustomizationContext } from '../../../../../utils/ClientCustomizationsProvider';
import { useMemo } from 'react';
import { PrimaryButton } from '../../../Products/ProductWizard/components/ProductPreview/components/Buttons';
import styled from 'styled-components';
import OfferOverridesModal from './OfferOverridesModal';
import { connect } from 'react-redux';
import { submitPOSDiscountOverrides } from '../../posAction';

const ContainedButton = styled(PrimaryButton)`
  height: 45px;
  border-radius: 20px;
  font-size: 12px;
`;
const OffersMappingTable = ({
  meta,
  requestParams,
  updateRequestParams,
  dirty,
  handleReset,
  values,
  initialValues,
  offers,
  getOffers,
  type,
  submitPOSDiscountValuesOffers,
  initialRequestParams,
  selectedValuePOS,
  allOffers,
  posDiscountsMappingFields,
  posDiscountsFieldsNum,
  businessList,
  submitPOSDiscountOverrides,
}) => {
  const { isOfferOverridesClient } = useContext(CustomizationContext);
  const searchRef = useRef();
  const [isConfirmModal, setIsConfirmModal] = useState(false);

  const discountOptions = discountOptionsModified(allOffers, type);

  const [newValue, setNewValue] = useState();
  const [newSearch, setNewSearch] = useState(null);
  const [newPage, setNewPage] = useState(null);
  const [searchString, setSearchString] = useState('');
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOfferOverrideModalOpen, setIsOfferOverrideModalOpen] =
    useState(false);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedOfferOverride, setSelectedOfferOverride] = useState(null);

  const handleChange = (newValue) => {
    searchRef.current = newValue;
    const searchString =
      typeof newValue === 'string'
        ? newValue
        : newValue?.inputValue || newValue?.title || '';
    setSearchString(searchString);

    if (!searchString) {
      setNewValue(null);
      getOffers(initialRequestParams);
      return;
    }
    setPage(1);
    if (dirty) {
      setNewValue(newValue);
      setIsConfirmModal(true);
    } else {
      getOffers(
        {
          searchString,
          page_number: 1,
          page_size: rowsPerPage,
        },
        true,
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = getOffers({
        searchString: searchString,
        page_number: page,
        page_size: rowsPerPage,
      });
    };
    fetchData();
  }, [page, rowsPerPage]);

  const discountMappingWithOverrides = useMemo(() => {
    if (isOfferOverridesClient) {
      const newPosDiscountsMappingFields = { ...posDiscountsMappingFields };
      newPosDiscountsMappingFields['Overrides'] = {
        type: 'button',
        label: 'Overrides',
        optional: true,
      };
      return newPosDiscountsMappingFields;
    }
    return posDiscountsMappingFields;
  }, [posDiscountsMappingFields, isOfferOverridesClient]);

  const headerNumber = Object.keys(discountMappingWithOverrides).length;

  const handleClickOverride = (offer) => {
    setSelectedOfferOverride(offer);
    setIsOfferOverrideModalOpen(true);
  };

  const modifiedBusinessList = businessList?.map((business) => {
    return {
      id: business.id,
      name: business.name,
      display_name: business.display_name,
      business_name: business.business_name,
    };
  });

  const overriddenBusinessIds = useMemo(() => {
    if (!selectedOfferOverride?.pos_mappings) return [];
    return (
      selectedOfferOverride?.pos_mappings
        ?.filter((mapping) => mapping?.business_id)
        .map((mapping) => mapping.business_id) || []
    );
  }, [selectedOfferOverride]);
  const handleSubmitOfferOverrides = async (values, method) => {
    const { businessIds, ...restValues } = values;
    await submitPOSDiscountOverrides(restValues, businessIds, method);
  };

  const handleOfferOverridesBatchComplete = async () => {
    await getOffers(initialRequestParams);
    setIsOfferOverrideModalOpen(false);
  };
  return (
    <MainDiv>
      <SelectDiv>
        <CreatableSelect
          onChange={handleChange}
          options={discountOptions || []}
          value={newValue}
          placeholder='Search for offers'
          isClearable={!dirty}
        />
      </SelectDiv>
      <Body>
        <DiscountDiv>
          <DiscountHeader>
            <div>{type.charAt(0).toUpperCase() + type.slice(1)} Name</div>
          </DiscountHeader>
          <LineDivider />
          {offers?.map((offer, index) => {
            return (
              <div key={offer.offer_id}>
                <DiscountNameCell>{offers[index].label}</DiscountNameCell>
              </div>
            );
          })}
        </DiscountDiv>

        <POSDiv>
          <POSFieldWrapper fieldsNumber={headerNumber}>
            {Object.keys(discountMappingWithOverrides)?.map((item, index) => {
              return (
                <POSHeader key={index}>
                  {item}{' '}
                  {discountMappingWithOverrides[item].optional ? '' : '*'}
                </POSHeader>
              );
            })}
            <LineDivider fieldsNumber={headerNumber} />

            <FieldArray
              name='offers'
              render={(arrayHelpers) => (
                <Fragment>
                  {offers?.map((offer, index) => {
                    return (
                      <Fragment key={`o_${offer.offer_id}`}>
                        {Object.keys(discountMappingWithOverrides)?.map(
                          (key) => {
                            return (
                              <POSValueCell key={`p_${offer.offer_id}_${key}`}>
                                {discountMappingWithOverrides[key].type ===
                                'string' ? (
                                  <TextFieldPOS
                                    name={`offers[${offer.index}].pos_mapping['${key}']`}
                                    value={
                                      offer?.pos_mapping
                                        ? offer?.pos_mapping[key]
                                        : ''
                                    }
                                    setFieldValue={
                                      arrayHelpers.form.setFieldValue
                                    }
                                  />
                                ) : discountMappingWithOverrides[key].type ===
                                  'button' ? (
                                  <ContainedButton
                                    buttonWidth={110}
                                    onClick={() => handleClickOverride(offer)}
                                  >
                                    Override
                                  </ContainedButton>
                                ) : (
                                  <ToogleFieldPOSWrapper>
                                    <ToogleFieldPOS
                                      name={`offers[${offer.index}].pos_mapping['${key}']`}
                                      onChange={arrayHelpers.form.setFieldValue}
                                    />
                                  </ToogleFieldPOSWrapper>
                                )}
                              </POSValueCell>
                            );
                          },
                        )}
                      </Fragment>
                    );
                  })}
                  <StickyButtons
                    isVisible={dirty}
                    handleDiscard={() => handleReset()}
                    handleSave={() => {
                      submitPOSDiscountValuesOffers(
                        values,
                        type,
                        initialValues,
                        selectedValuePOS,
                        null,
                        null,
                        meta.page_size,
                        meta.page_number,
                        posDiscountsMappingFields,
                      );
                      setNewValue('');
                    }}
                    title='Offers POS Mapping'
                  />
                </Fragment>
              )}
            />
          </POSFieldWrapper>
        </POSDiv>
      </Body>

      <CustomePagination
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        hasNextPage={meta.has_next_page}
        disabled={dirty}
      />
      {isOfferOverrideModalOpen && (
        <OfferOverridesModal
          isOverrideModal={isOfferOverrideModalOpen}
          setIsOverrideModal={setIsOfferOverrideModalOpen}
          handleSubmitProductOverrides={() => {}}
          selectedLocations={selectedLocations}
          setSelectedLocations={setSelectedLocations}
          modifiedBusinessList={modifiedBusinessList}
          posDiscountsMappingFields={posDiscountsMappingFields}
          selectedOfferOverride={selectedOfferOverride}
          onSubmit={handleSubmitOfferOverrides}
          onBatchComplete={handleOfferOverridesBatchComplete}
          overriddenBusinessIds={overriddenBusinessIds}
        />
      )}

      {isConfirmModal && (
        <ConfirmUnsavedChangesModal
          toggleConfirmModal={() => setIsConfirmModal(false)}
          handleSave={() => {
            setIsConfirmModal(false);
            submitPOSDiscountValuesOffers(
              values,
              type,
              initialValues,
              selectedValuePOS,
              newValue,
              newSearch,
              meta.page_size,
              newPage ? newPage : meta.page_number,
              posDiscountsMappingFields,
            );
            setNewSearch(null);
            setNewPage(null);
          }}
        />
      )}
    </MainDiv>
  );
};
const mapStateToProps = (state) => ({
  businessList: state.businessLocationsList.businessLocationsOfMerchant,
  currentAssociatedBusinesses:
    state.productsReducer.productSelectedBusinessesInitialValues,
});

export default connect(mapStateToProps, { submitPOSDiscountOverrides })(
  OffersMappingTable,
);
